// extracted by mini-css-extract-plugin
export default {"heading-xs":"index-heading-xs","heading-sm":"index-heading-sm","heading-md":"index-heading-md","heading-lg":"index-heading-lg","heading-xl":"index-heading-xl"};